const AvisoLegal = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-4">
      <h1 className="text-2xl font-black uppercase italic">Aviso Legal</h1>

      <p>
        En cumplimiento de la Ley 34/2002, de Servicios de la Sociedad de la Información y del Comercio Electrónico, se informa que el presente sitio web SANAN es titularidad de:
      </p>

      <ul className="list-disc pl-6">
        <li>Titular: Jordi San Andres Salvador</li>
        <li>NIF: 47421743K</li>
        <li>Email de contacto: pedidos@sanan-wear.com</li>
        <li>Actividad: Venta de ropa online</li>
      </ul>

      <p>
        El acceso y uso de este sitio web atribuye la condición de usuario e implica la aceptación de las presentes condiciones.
      </p>

      <p>
        Todos los contenidos del sitio web (textos, imágenes, diseño, logotipos, etc.) son propiedad del titular o de terceros con licencia, quedando prohibida su reproducción sin autorización expresa.
      </p>

      <p>
        La legislación aplicable será la española y cualquier controversia se someterá a los juzgados y tribunales del domicilio del titular.
      </p>
    </div>
  );
};

export default AvisoLegal;
